export const RES_IDLE = "idle";
export const RES_LOADING = "loading";
export const RES_SUCCESS = "succeeded";
export const RES_FAILED = "failed";

export enum RES_STATUS {
  IDLE = "idle",
  LOADING = "loading",
  FAILED = "failed",
  SUCCEEDED = "succeeded",
}

export const SHOW_ALL = "all";
export const SHOW_SINGLE = "single";
